import { Typography, theme } from "antd";
import { useIntl } from "react-intl";
import { DefaultButton } from "./DefaultButton";

const { useToken } = theme;

type Props = {
  disabled?: boolean;
};

export const RosterAndStaffButton = ({ disabled }: Props) => {
  const { formatMessage } = useIntl();
  const { token } = useToken();

  const buttonIcon =
    disabled === undefined ? (
      ""
    ) : disabled !== true ? (
      <i className="fa-solid fa-lock-open"></i>
    ) : (
      <i className="fa-solid fa-lock"></i>
    );
  return (
    <DefaultButton type="text" icon={buttonIcon}>
      <Typography.Text strong style={{ color: token.colorPrimary }} className="text-upper">
        {formatMessage({ id: "button.rosterAndStaff" })}
      </Typography.Text>
    </DefaultButton>
  );
};
